import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { SliderInput } from "../inputs/slider-input"

interface SliderFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof SliderInput>, "value" | "onChange" | "error"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function SliderField<T extends FieldValues>({ field, id, description, ...props }: SliderFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <SliderInput id={id} value={field.value} onChange={field.onChange} error={!!error} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  volume: number;
}

<FormField
  control={form.control}
  name="volume"
  render={({ field }) => (
    <SliderField<FormData>
      field={field}
      id="volume-slider"
      label="Volume"
      description="Adjust the volume level"
      min={0}
      max={100}
      step={1}
      formatValue={(value) => `${value}%`}
    />
  )}
/>
*/
